<div>
<div [ngClass]="{'mox-style mox-ui-page-container mox-ui-page-container-pd-btm': claim.isMox()}">
    <div class="prev-bar" *ngIf="transactionInfo.isTravelProduct()">
        <a (click)="back()" style="color: #0064c1" class="btn btn-secondary new-btn"><i class="fas fa-arrow-left"></i>&nbsp;{{'claimDetails.body.back' | translate}}&nbsp;</a>
    </div>
    <div class="col-12">
        <span *ngIf="transactionInfo.isTravelProduct() || transactionInfo.isAccidentProduct()">
        <h5>{{ 'pageSelectInsured.body.title' | translate}}</h5>
        <p *ngIf="transactionInfo.isTravelPersonal() || transactionInfo.isTravelCorporateInsuredPerson()">
            {{ 'pageSelectInsured.body.selectLabel' | translate}}</p>
        <p *ngIf="transactionInfo.isAccidentProduct() && !transactionInfo.isGroupAccidentProduct()">
            {{ 'pageSelectInsured.body.selectLabel' | translate}}</p>
        <p *ngIf="transactionInfo.isAccidentProduct() && transactionInfo.isGroupAccidentProduct()">
            {{ 'pageSelectInsured.body.selectLabelGroup' | translate}}</p>
       </span>
        <span *ngIf="transactionInfo.isDomesticHelperProduct()">
        <h5>{{ 'domesticHelperClaim.selectInsured.titleHelper' | translate}}</h5>
        <p>{{'domesticHelperClaim.selectInsured.title' | translate}}</p>
        </span>
        <qnect-notification-messages [notifications]="notifications"></qnect-notification-messages>
    </div>
    <div class="row add-claim-content insuredBox col-12">
        <ng-container *ngIf="transactionInfo.isDomesticHelperProduct() 
            || (transactionInfo.isTravelPersonal() || transactionInfo.isTravelCorporateInsuredPerson()) 
            || (transactionInfo.isAccidentProduct() && !transactionInfo.isGroupAccidentProduct())">
            <div class="col-lg-4 col-md-6 col-6" *ngFor="let person of insuredPersonList; let i = index"
                (click)="choosePerson(i, person)" [ngClass]="{'insured-item': claim.isMox()}">
                <div class="cperson-wrapper text-center toggleActive" [class.active]="selectedPerson?.getInsuredName() === person.getInsuredName() && choosedPersonId === i" [ngClass]="{'select-item check-pos-left contact-person check-insured-person-pos-left': claim.isMox()}">
                    <div class="cpreson-outter">
                        <h5 class="insuredNameWrap">{{person.getInsuredName()}}</h5>
                        <span *ngIf="transactionInfo.isTravelProduct() || transactionInfo.isDomesticHelperProduct()">{{person.getInsuredPersonNationalIdNumber() | formatHKID}}</span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="row">
        <div class="col-12" *ngIf="transactionInfo.isTravelPersonal() || (transactionInfo.isAccidentProduct() && !transactionInfo.isGroupAccidentProduct())">
            <div class="col-12">
                <ng-container *ngIf="!claim.isMox()">
                    <p><a href="javascript:;" (click)="showContent()">{{ 'pageSelectInsured.body.searchPerson.desc1' | translate}}</a>
                        {{ 'pageSelectInsured.body.searchPerson.desc2' | translate}}</p>
                </ng-container>
                <ng-container *ngIf="claim.isMox()">
                    <br/><p><strong><a href="javascript:;" (click)="showContent()">{{ 'pageSelectInsured.body.searchPerson.desc1' | translate}}</a></strong>
                    {{ 'pageSelectInsured.body.searchPerson.desc2' | translate}}
                    </p><br/>
                </ng-container>
            </div>
            <div class="col-12 hide" *ngIf="showAdditionalClaimantMessage">
                <small id="modalLink" (click)="open(includeMoreInsured,'includeMoreInsured')">{{'pageSelectInsured.body.includeMore.title' | translate}}</small>
                <BR><BR>
            </div>
        </div>
        <div class="col-12" *ngIf="transactionInfo.isDomesticHelperProduct() && insuredPersonList.length > 0">
            <div class="col-12">
                <a href="javascript:;" (click)="showContent()" class="click-more">{{ 'pageSelectInsured.body.searchPerson.desc1' | translate}}</a>
                <p class="searchPerson-desc">{{'domesticHelperClaim.selectInsured.otherHelperSection' | translate}}</p>
            </div>
        </div>
    </div>
    <div class="row col-12" [style.display]="showMoreContent ? 'block' : 'none'" [ngClass]="{'mox-ui-form-container': claim.isMox()}">
        <div [ngClass]="transactionInfo.isTravelCorporatePolicyHolder() ? 'col-lg-8 col-md-12' : 'col-lg-6 col-md-12'">
            <form class="add-claim-form">
                <div *ngIf="transactionInfo.isTravelProduct() || transactionInfo.isAccidentProduct()">
                    <div class="form-group">
                        <qnect-ui #OTHER_INSURED_PERSON_NAME [fieldId]="'OTHER_INSURED_PERSON_NAME'" [formGroup]="otherInsuredPersonForm" name="otherPersonName"></qnect-ui>
                    </div>
                    <div class="form-group" *ngIf="transactionInfo.getRealCountry() === 'HKG'" [ngClass]="{'mox-ui-id-field': claim.isMox()}">
                        <div [ngClass]="{'mox-ui-display-flex mox-ui-justify-content-space-between mox-ui-align-items-flex-end': claim.isMox()}">
                        <span [ngClass]="{'col-lg-4': claim.isMox()}">
                            <qnect-ui #OTHER_INSURED_PERSON_HKID_PASSPORT [fieldId]="'OTHER_INSURED_PERSON_HKID_PASSPORT'" [formGroup]="otherInsuredPersonForm" name="otherPersonIdType"></qnect-ui>
                        </span>
                        <span *ngIf="this.otherIdType == 'hkid'" [ngClass]="{'col-lg-8': claim.isMox()}"> <qnect-ui #OTHER_INSURED_PERSON_HKID_1 [fieldId]="'OTHER_INSURED_PERSON_HKID_1'" [formGroup]="otherInsuredPersonForm" [hkidValidator]="'hkid'" name="otherPersonHKID"></qnect-ui></span>
                        <span *ngIf="this.otherIdType == 'passport'" [ngClass]="{'col-lg-8': claim.isMox()}"> <qnect-ui #OTHER_INSURED_PERSON_PASSPORT [fieldId]="'OTHER_INSURED_PERSON_PASSPORT'" [formGroup]="otherInsuredPersonForm" name="otherPersonHKID"></qnect-ui></span>
                        </div>
                    </div>
                    <div class="form-group" *ngIf="transactionInfo.getRealCountry() !== 'HKG'">
                        <qnect-ui #OTHER_INSURED_PERSON_HKID [fieldId]="'OTHER_INSURED_PERSON_HKID'" [formGroup]="otherInsuredPersonForm" name="otherPersonHKID"></qnect-ui>
                    </div>
                    <div class="form-group" (click)="scrollIntoView(insureddobsection)">
                        <qnect-ui #OTHER_INSURED_PERSON_DOB [fieldId]="'OTHER_INSURED_PERSON_DOB'" [formGroup]="otherInsuredPersonForm" name="otherPersonDOB"></qnect-ui>
                    </div>
                </div>
                <div *ngIf="transactionInfo.isDomesticHelperProduct()">
                    <div class="form-group">
                        <qnect-ui #DMH_OTHER_HELPER_NAME [fieldId]="'DMH_OTHER_HELPER_NAME'" [formGroup]="otherInsuredPersonForm" name="otherPersonName"></qnect-ui>
                    </div>
                    <div class="form-group" [ngClass]="{'mox-ui-id-field': claim.isMox()}">
                        <div [ngClass]="{'mox-ui-display-flex mox-ui-justify-content-space-between mox-ui-align-items-flex-end': claim.isMox()}">
                        <span [ngClass]="{'col-lg-4': claim.isMox()}">
                            <qnect-ui #DMH_OTHER_HELPER_IDTYPE [fieldId]="'DMH_OTHER_HELPER_IDTYPE'" [formGroup]="otherInsuredPersonForm" name="otherPersonIdType"></qnect-ui>
                        </span>
                        <span *ngIf="this.otherIdType == 'hkid'" [ngClass]="{'col-lg-8': claim.isMox()}"> <qnect-ui #DMH_OTHER_HELPER_HKID [fieldId]="'DMH_OTHER_HELPER_HKID'" [formGroup]="otherInsuredPersonForm" [hkidValidator]="'hkid'" name="otherPersonHKID"></qnect-ui></span>
                        <span *ngIf="this.otherIdType == 'passport'" [ngClass]="{'col-lg-8': claim.isMox()}"> <qnect-ui #DMH_OTHER_HELPER_PASSPORT [fieldId]="'DMH_OTHER_HELPER_PASSPORT'" [formGroup]="otherInsuredPersonForm" name="otherPersonHKID"></qnect-ui></span>
                        </div>
                    </div>
                    <div class="form-group" (click)="scrollIntoView(insureddobsection)" >
                        <qnect-ui #DMH_OTHER_HELPER_DOB [fieldId]="'DMH_OTHER_HELPER_DOB'" [formGroup]="otherInsuredPersonForm" name="otherPersonDOB"
                                  [aboveMaxDateValidator]="this.claim.getDateOfLoss()"></qnect-ui>
                    </div>
                </div>

                <div class="form-group pad-top5" *ngIf="transactionInfo.isDomesticHelperProduct() ||  transactionInfo.isTravelPersonal() 
                    || (transactionInfo.isAccidentProduct() && !transactionInfo.isGroupAccidentProduct())">
                    <input type="button" (click)="addInsuredPerson()" class="btn btn-secondary new-btn add-claim-btn btn-save"
                        value="{{ 'pageSelectInsured.body.save' | translate }}" [ngClass]="{'mox-ui-btn mox-ui-btn-width': claim.isMox()}">
                </div>
            </form>
        </div>
    </div>
    <div class="col-lg-6 col-md-12 hide">
        &nbsp;
    </div>
    <div class="submit-bar hide" #insureddobsection>
        <abandon-button></abandon-button>
        <button (click)="goToNext()" class="new-btn btn btn-primary float-right">{{ 'pageSelectInsured.body.button' | translate}} <i class="fas fa-arrow-right"></i></button>
    </div>
    <ng-container *ngIf="isQnectOrCustomerPortalMILDMH">
        <div class="row col-12" style="justify-content:left;">
            <div class="col-lg-6 col-md-8">
                <qnect-ui #GENERIC_DATE_OF_LOSS [fieldId]="'GENERIC_DATE_OF_LOSS'" [formGroup]="otherForm"
                          [dynamicLabel]="'domesticHelperClaim.dateOfLoss'" name="dateOfLoss"></qnect-ui>
            </div>
        </div>
    </ng-container>
</div>
<div class="visible mox-ui-page-container mox-ui-page-container-rm-pd-top mox-ui-page-container-rm-pd-btm mox-ui-insured-info" *ngIf="showAdditionalClaimantMessage && claim.isMox()">
    <div class="mox-ui-page-container-pd-30 mox-ui-page-container-bg mox-ui-m-width-100vw mox-ui-m-side-margin-neg-30">
        <p><strong>{{'pageSelectInsured.body.includeMore.title' | translate}}</strong></p>
        <br/>
        <p>{{'pageSelectInsured.body.includeMore.line1' | translate}}</p>
        <br/>
        <p [innerHTML]="'pageSelectInsured.body.includeMore.line2' | translate"></p>
        <br/>
        <p>{{'pageSelectInsured.body.includeMore.line3' | translate}}</p>
    </div>
</div>
<br class="hide" />
<div [ngClass]="{'visible mox-ui-page-container': claim.isMox()}">
    <br class="hide" />
    <div class="submit-bar" #insureddobsection>
        <abandon-button></abandon-button>
        <button (click)="goToNext()" class="new-btn btn btn-primary float-right">{{ 'pageSelectInsured.body.button' | translate}} <i class="fas fa-arrow-right"></i></button>
    </div>
</div>
</div>

<ng-template #selected_insured_change let-c="close" let-d="dismiss">
    <div class="alert-modal" [ngClass]="{'mox-style mox-ui-popup-alert': claim.isMox()}">
    <div class="modal-header" [ngClass]="{'mox-ui-popup-container-header mox-ui-popup-header-color': claim.isMox()}">
        <h5 class="modal-title">{{'additionalClaimant.confirmDelete' | translate }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true" *ngIf="!claim.isMox()">&times;</span>
            <div [ngClass]="{'mox-ui-popup-close mox-ui-popup-close-pos-relative mox-ui-popup-close-sm': claim.isMox()}">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </button>
    </div>
    <div class="modal-body" [ngClass]="{'modal-body-left mox-ui-popup-container-body mox-ui-popup-container-body-pd-btm-0 mox-ui-popup-container-body-pd-top-btm-26 mox-ui-popup-container-body-pd-border-btm': claim.isMox()}">
        <p>{{'additionalClaimant.confirmDeleteDesc1' | translate }} tewaeqweqweqw</p>
        <p>{{'additionalClaimant.confirmDeleteDesc2' | translate }} asdasdasdasdd</p>
    </div>
    <div class="modal-footer" [ngClass]="{'mox-ui-popup-container-footer mox-ui-popup-container-footer-flex-wrap mox-ui-popup-footer-flex-space-between mox-ui-popup-container-footer-upload-pd': claim.isMox()}">
        <div class="col-md-6 text-right" [ngClass]="{'text-center mox-ui-flex-48per': claim.isMox()}">
            <button type="button" class="btn btn-primary btn-sm" (click)="removeSelectedClaimTypes()" [ngClass]="{'mox-ui-popup-container-footer-btn mox-ui-btn-width-100per': claim.isMox()}">{{'sideMenu.deleteClaim.yes' | translate }}</button>
        </div>
        <div class="col-md-6 text-left" [ngClass]="{'text-center mox-ui-flex-48per': claim.isMox()}">
            <button type="button" class="btn btn-default btn-sm" (click)="closeChangeInsuredModal()" [ngClass]="{'mox-ui-popup-container-footer-btn mox-ui-btn-width-100per': claim.isMox()}">{{'sideMenu.deleteClaim.no' | translate }}</button>
        </div>
    </div>
    </div>
</ng-template>
<ng-template #multiClaimantInfo let-c="close" let-d="dismiss">
    <div class="alert-modal" [ngClass]="{'mox-style mox-ui-popup-alert': claim.isMox()}">
    <div class="modal-header" [ngClass]="{'mox-ui-popup-container-header mox-ui-popup-header-color': claim.isMox()}">
        <h5 class="modal-title">{{'additionalClaimant.confirmDelete' | translate }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true" *ngIf="!claim.isMox()">&times;</span>
            <div [ngClass]="{'mox-ui-popup-close mox-ui-popup-close-pos-relative mox-ui-popup-close-sm': claim.isMox()}">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </button>
    </div>
    <div class="modal-body" [ngClass]="{'modal-body-left mox-ui-popup-container-body mox-ui-popup-container-body-pd-btm-0 mox-ui-popup-container-body-pd-top-btm-26 mox-ui-popup-container-body-pd-border-btm': claim.isMox()}">
        <p>{{'additionalClaimant.confirmDeleteDesc1' | translate }}</p>
        <p>{{'additionalClaimant.confirmDeleteDesc2' | translate }}</p>
    </div>
    <div class="modal-footer" [ngClass]="{'mox-ui-popup-container-footer mox-ui-popup-container-footer-flex-wrap mox-ui-popup-footer-flex-space-between mox-ui-popup-container-footer-upload-pd': claim.isMox()}">
        <button type="button" class="btn btn-light" (click)="c('Close click')" [ngClass]="{'mox-ui-popup-container-footer-btn mox-ui-width-50per-20 mox-ui-popup-footer-close-btn-m-auto mox-ui-popup-mobile-footer-single-btn-width': claim.isMox()}">{{'completePage.body.generalButtonLabels.close' | translate}}</button>
    </div>
    </div>
</ng-template>
<ng-template #includeMoreInsured let-c="close" let-d="dismiss">
    <div class="alert-modal" [ngClass]="{'mox-style mox-ui-popup-alert': claim.isMox()}">
    <div class="modal-header" [ngClass]="{'mox-ui-popup-container-header mox-ui-popup-header-color': claim.isMox()}">
      <h4 class="modal-title cursor-pointer">{{'pageSelectInsured.body.includeMore.title' | translate}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true" *ngIf="!claim.isMox()">&times;</span>
        <div [ngClass]="{'mox-ui-popup-close mox-ui-popup-close-pos-relative mox-ui-popup-close-sm': claim.isMox()}">
            <span></span>
            <span></span>
            <span></span>
        </div>
      </button>
    </div>
    <div class="modal-body modal-body-left" [ngClass]="{'mox-ui-popup-container-body mox-ui-popup-container-body-pd-btm-0 mox-ui-popup-container-body-pd-top-btm-26 mox-ui-popup-container-body-pd-border-btm': claim.isMox()}">
        <p>{{'pageSelectInsured.body.includeMore.line1' | translate}}</p>
        <p><span [innerHtml]="'pageSelectInsured.body.includeMore.line2' | translate"></span></p>
        <p>{{'pageSelectInsured.body.includeMore.line3' | translate}}</p>
    </div>
    <div class="modal-footer" *ngIf="!claim.isMox()">
      <button type="button" class="btn btn-light" (click)="c('Close click')">{{'completePage.body.generalButtonLabels.close' | translate}}</button>
    </div>    
    </div>
  </ng-template>
